import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import { deacService } from '../../services/central-api/deac';
import { StyleProp, TextStyle } from 'react-native';
import ExternalSelect from '../ExternalSelect';
import { DEFAULT_PASTEL_COLORS, DEFAULT_PASTEL_TEXT_COLORS } from '../../styles/colorPalettes';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    zIndex: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
}

export default function VacancyTagDropdown({ value, setValue, zIndex, labelStyle, viewStyle }: Props) {
    const [selectableVacancyTags, setSelectableVacancyTags] = useState<{ label: string; value: number; }[]>([]);

    async function loadTags() {
        try {
            const tags = await deacService.getTagsSimplified();
            setSelectableVacancyTags(tags.map((tag) => {
                const index = DEFAULT_PASTEL_COLORS.indexOf(tag.color);
                return {
                    value: tag.id,
                    label: tag.name,
                    color: tag.color,
                    textColor: DEFAULT_PASTEL_TEXT_COLORS[index],
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        loadTags();
    }, []);

    return (
        <ExternalSelect
            label={translate('tags')}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
            items={selectableVacancyTags}
            multiple={true}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            selectedLabel={translate('selectedTags')}
            onRemove={(items) => setValue(items as number[])}
            initialSelectedItems={selectableVacancyTags.filter(item => value.includes(item.value))}
        />
    );
}
